export default "__VITE_ASSET__CnEuwwuF__"